import React from "react";
import { useTranslation } from "react-i18next";
import { BriefDetails } from "src/model/model";

const BRIEF_LABELS: Record<string, string> = {
  expectedTone: "interactionDetails.tone",
  expectedKeyPoints: "interactionDetails.keyPoints",
  expectedLabel: "interactionDetails.label",
  expectedNextSceneIntent: "interactionDetails.nextSceneIntent",
  expectedCountdownSeconds: "interactionDetails.countdownSeconds",
  expectedQuestion: "interactionDetails.question",
  expectedCorrectAnswer: "interactionDetails.correctAnswer",
  expectedAnswerOptions: "interactionDetails.answerOptions",
  expectedDifficulty: "interactionDetails.difficulty",
  expectedKeywords: "interactionDetails.keywords",
  expectedPersonaName: "interactionDetails.personaName",
  expectedPersonaTone: "interactionDetails.personaTone",
  expectedPersonaTraits: "interactionDetails.personaTraits",
  expectedKeyTopics: "interactionDetails.keyTopics",
  expectedSituationContext: "interactionDetails.situationContext",
  expectedUserRole: "interactionDetails.userRole",
  expectedSuccessCriteria: "interactionDetails.successCriteria",
  expectedFailureCriteria: "interactionDetails.failureCriteria",
  expectedHotspotSubjects: "interactionDetails.hotspotSubjects",
  expectedAssetDescription: "interactionDetails.assetDescription",
  expectedCategories: "interactionDetails.categories",
  expectedScoreCriteria: "interactionDetails.scoreCriteria",
};

interface GenericKeyValueDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const GenericKeyValueDetails: React.FC<GenericKeyValueDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  const ns = "pages.chat";

  if (!data || typeof data !== "object") return null;

  const entries = Object.entries(data).filter(([, v]) => {
    if (v === null || v === undefined) return false;
    if (Array.isArray(v) && v.length === 0) return false;
    if (typeof v === "string" && v.length === 0) return false;
    return true;
  });

  if (entries.length === 0) return null;

  return (
    <div className="space-y-1 text-[11px] text-gray-700">
      {entries.map(([key, value]) => {
        const labelKey = mode === "plan" ? BRIEF_LABELS[key] : undefined;
        const label = labelKey ? t(`${ns}.${labelKey}`) : key;
        const display = Array.isArray(value) ? value.join(", ") : String(value);
        return (
          <div key={key} className="flex gap-1.5">
            <span className="font-medium text-gray-500 shrink-0">{label} :</span>
            <span>{display}</span>
          </div>
        );
      })}
    </div>
  );
};

export default GenericKeyValueDetails;
